/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ movement: NonNullable<unknown> }} Prescription_Exhausted_CatalogueInputs */

const en_us2_prescription_exhausted_catalogue = /** @type {(inputs: Prescription_Exhausted_CatalogueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`That is every ${i?.movement} exercise in the catalogue.`)
};

const pt_br2_prescription_exhausted_catalogue = /** @type {(inputs: Prescription_Exhausted_CatalogueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Esses são todos os exercícios de ${i?.movement} no catálogo.`)
};

const es_419_prescription_exhausted_catalogue = /** @type {(inputs: Prescription_Exhausted_CatalogueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Esos son todos los ejercicios de ${i?.movement} del catálogo.`)
};

const pt_pt2_prescription_exhausted_catalogue = /** @type {(inputs: Prescription_Exhausted_CatalogueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Estes são todos os exercícios de ${i?.movement} do catálogo.`)
};

const fr_fr2_prescription_exhausted_catalogue = /** @type {(inputs: Prescription_Exhausted_CatalogueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ce sont tous les exercices de ${i?.movement} du catalogue.`)
};

const de_de2_prescription_exhausted_catalogue = /** @type {(inputs: Prescription_Exhausted_CatalogueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Das sind alle Übungen für „${i?.movement}“ im Katalog.`)
};

const it_it2_prescription_exhausted_catalogue = /** @type {(inputs: Prescription_Exhausted_CatalogueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Questi sono tutti gli esercizi di ${i?.movement} del catalogo.`)
};

/**
* | output |
* | --- |
* | "That is every {movement} exercise in the catalogue." |
*
* @param {Prescription_Exhausted_CatalogueInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const prescription_exhausted_catalogue = /** @type {((inputs: Prescription_Exhausted_CatalogueInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prescription_Exhausted_CatalogueInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_prescription_exhausted_catalogue(inputs)
	if (locale === "es-419") return es_419_prescription_exhausted_catalogue(inputs)
	if (locale === "pt-PT") return pt_pt2_prescription_exhausted_catalogue(inputs)
	if (locale === "fr-FR") return fr_fr2_prescription_exhausted_catalogue(inputs)
	if (locale === "de-DE") return de_de2_prescription_exhausted_catalogue(inputs)
	if (locale === "it-IT") return it_it2_prescription_exhausted_catalogue(inputs)
	return en_us2_prescription_exhausted_catalogue(inputs)
});
export { prescription_exhausted_catalogue as "prescription.exhausted.catalogue" }